// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BagCounter_wrapper__zafkZ","icon":"BagCounter_icon__mo6LC","counter":"BagCounter_counter__CKb76"};